/* Checkbox "vorzeitiger Beginn der ärztlichen Beratung" im Warenkorb.
   Ohne Haken ist der Checkout-Button (data-button) gesperrt: aria-disabled
   statt disabled, damit ein Klick ankommt, abgefangen wird und den Hinweis
   zeigt. Als Rückfall ist die Checkbox zusätzlich Pflichtfeld des Formulars.
   Haken -> Warenkorb-Attribut mit Zeitstempel, landet an der Bestellung.
   Kein Haken -> Attribut leer (Shopify löscht leere Attribute).
   Auf der Warenkorbseite wird der Footer bei Mengenänderungen nicht neu
   gerendert, deshalb blendet das Element sich über cartUpdate selbst ein/aus. */

if (!customElements.get('consultation-consent')) {
  class ConsultationConsent extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      this.alert = this.querySelector('.consultation-consent__alert');
      this.onChange = this.handleChange.bind(this);
      this.onButtonClick = this.handleButtonClick.bind(this);
      this.input.addEventListener('change', this.onChange);
      this.button = document.getElementById(this.dataset.button);
      if (this.button) this.button.addEventListener('click', this.onButtonClick);
      this.syncButton();

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          // Nur cart.js liefert den kompletten Warenkorb, product-form nur die neuen Artikel
          if (event.source !== 'cart-items') return;
          const items = event.cartData?.items;
          if (!Array.isArray(items)) return;
          this.toggle(items.some((item) => item.product_type === 'Beratung'));
        });
      }
    }

    disconnectedCallback() {
      this.input.removeEventListener('change', this.onChange);
      if (this.button) this.button.removeEventListener('click', this.onButtonClick);
      if (this.unsubscribe) this.unsubscribe();
    }

    get blocked() {
      return !this.input.disabled && !this.input.checked;
    }

    // Gesperrt nur, solange die Beratung im Warenkorb liegt und der Haken fehlt
    syncButton() {
      if (!this.button) return;
      const blocked = this.blocked;
      if (blocked) {
        this.button.setAttribute('aria-disabled', 'true');
      } else {
        this.button.removeAttribute('aria-disabled');
      }
      this.button.classList.toggle('consultation-consent__blocked', blocked);
      if (!blocked) this.hideAlert();
    }

    handleButtonClick(event) {
      if (!this.blocked) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.showAlert();
    }

    showAlert() {
      this.alert.hidden = false;
      // Klasse neu setzen, damit Wackeln und Aufploppen bei jedem Klick laufen
      this.classList.remove('consultation-consent--alert');
      this.alert.style.animation = 'none';
      void this.offsetWidth;
      this.alert.style.animation = '';
      this.classList.add('consultation-consent--alert');
      this.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      clearTimeout(this.alertTimer);
      this.alertTimer = setTimeout(() => this.hideAlert(), 5000);
    }

    hideAlert() {
      clearTimeout(this.alertTimer);
      this.alert.hidden = true;
      this.classList.remove('consultation-consent--alert');
    }

    toggle(active) {
      this.hidden = !active;
      this.input.disabled = !active;
      this.syncButton();
    }

    handleChange() {
      this.syncButton();
      this.save();
    }

    save() {
      const value = this.input.checked ? `${this.dataset.value} (${new Date().toISOString()})` : '';
      this.input.value = value || this.dataset.value;
      fetch(`${window.routes?.cart_url || '/cart'}/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { [this.dataset.attribute]: value } }),
      }).catch(() => {});
    }
  }

  customElements.define('consultation-consent', ConsultationConsent);
}
